import React from 'react'
import { object, bool, string } from 'prop-types'
import {
  Color,
  H1,
  Paragraph,
  Header,
  List,
  Grid
} from '@cobalt/cobalt-react-components'
import {
  USER_SETTINGS_TITLE,
  USER_SETTINGS_DESCRIPTION
} from '../../constants/ui.labels'
import PasswordSettings from '../../components/PasswordSettings'
import MFASettings from '../../components/MFASettings'
import { withBaseWithMenu } from '../../components/Base'

const HeaderTitle = () => (
  <Header contained>
    <Header.Heading>
      <Header.Title>
        <H1>{USER_SETTINGS_TITLE}</H1>
      </Header.Title>
      <Header.Description>
        <Paragraph color={Color.gray[600]}>
          {USER_SETTINGS_DESCRIPTION}
        </Paragraph>
      </Header.Description>
    </Header.Heading>
  </Header>
)

const UserSettings = ({
  passwordActions,
  passwordSettings,
  mfaActions,
  mfaSettings,
  isLocalLoginEnabled,
  siteKey
}) => (
  <Grid noPadding>
    <Grid.Group>
      <Grid.Column>
        <List>
          <List.Item borderBottom>
            <PasswordSettings
              {...passwordActions}
              {...passwordSettings}
              isLocalLoginEnabled={isLocalLoginEnabled}
            />
          </List.Item>
          <List.Item>
            <MFASettings
              {...mfaActions}
              {...mfaSettings}
              isLocalLoginEnabled={isLocalLoginEnabled}
              siteKey={siteKey}
            />
          </List.Item>
        </List>
      </Grid.Column>
    </Grid.Group>
  </Grid>
)

UserSettings.propTypes = {
  passwordActions: object.isRequired,
  mfaActions: object.isRequired,
  passwordSettings: object.isRequired,
  mfaSettings: object.isRequired,
  isLocalLoginEnabled: bool.isRequired,
  siteKey: string.isRequired
}

export default withBaseWithMenu(UserSettings, HeaderTitle)
